<mat-slide-toggle
  [checked]="item.isActive"
  (change)="toggle()"
></mat-slide-toggle>
